module.exports = __webpack_public_path__ + "static/media/dianxinyewuB2B2Cfenxiao.9cf83c75.png";